/**
 * The one scale both Activity charts use: maps a value in [d0, d1] onto
 * [r0, r1] linearly. A zero-width domain maps everything to the middle of
 * the range, so a single point or a flat line is still drawn.
 */
export function linearScale([d0, d1], [r0, r1]) {
  if (d0 === d1) return () => (r0 + r1) / 2;
  return (value) => r0 + ((value - d0) / (d1 - d0)) * (r1 - r0);
}
